module.exports = __webpack_public_path__ + "static/media/dress-4.4f51cf35.jpg";